<template>
  <b-modal
    id="update-schedule-type"
    hide-footer
    @shown="getScheduleById"
    no-close-on-backdrop
    size="md"
    modal-class="modern-modal"
  >
    <template v-slot:modal-title>
      <div class="modal-title-modern">
        <i class="fas fa-calendar-plus mr-2"></i>
        Cadastrar tipo do Agendamento
      </div>
    </template>

    <div class="modal-content-modern">
      <form @submit.prevent="update">
        <div class="form-grid">
          <div class="form-section">
            <div class="section-header">
              <h4 class="section-title">
                <i class="fas fa-info-circle mr-2"></i>
                Informações Básicas
              </h4>
            </div>
            <div class="section-content">
              <div class="form-group">
                <LabelRequiredField label="Nome Tipo de Agendamento" />

                <div class="input-wrapper">
                  <i class="fas fa-folder input-icon"></i>

                  <input
                    type="text"
                    :disabled="errors.length > 0"
                    v-model="schedule_type.name"
                    class="modern-input"
                    placeholder="Digite o nome do tipo de agendamento"
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="form-section">
            <div class="section-header">
              <h4 class="section-title">
                <i class="fas fa-layer-group mr-2"></i>
                Status
              </h4>
            </div>
            <div class="section-content">
              <div class="toggle-group">
                <button
                  type="button"
                  :disabled="errors.length > 0"
                  :class="['toggle-btn', { active: schedule_type.active == 1 }]"
                  @click="schedule_type.active = 1"
                >
                  <i class="fas fa-check mr-2"></i>

                  <span>Ativo</span>
                </button>

                <button
                  type="button"
                  :disabled="errors.length > 0"
                  :class="['toggle-btn', { active: schedule_type.active == 0 }]"
                  @click="schedule_type.active = 0"
                >
                  <i class="fas fa-times mr-2"></i>

                  <span>Inativo</span>
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="errors-section" v-if="errors.length > 0">
          <ErrorsMessages :errors="errors" />
        </div>

        <div class="form-actions">
          <v-btn
            :disabled="loading || errors.length > 0"
            type="submit"
            class="btn-save-modern"
          >
            <i class="fas fa-save mr-2"></i>

            <div v-if="loading">Carregando...</div>

            <div v-if="errors.length > 0">Erro ao buscar...</div>

            <div v-if="!loading && errors.length == 0">
              Salvar tipo de Agendamento
            </div>
          </v-btn>
        </div>
      </form>
    </div>
  </b-modal>
</template>

<script>
import ErrorsMessages from "../Components/ErrorsMessages.vue";

import LabelRequiredField from "../Components/LabelRequiredField";

import api from "../../services/api";

import toast from "../../lib/ToastNotification";

export default {
  name: "UpdateModal",

  components: {
    LabelRequiredField,
    ErrorsMessages,
  },

  data() {
    return {
      errors: [],

      schedule_type: [],

      loading: false,
    };
  },

  props: {
    schedule_type_id: {
      type: Number,
      default: null,
    },
  },

  methods: {
    async getScheduleById() {
      try {
        this.loading = true;

        this.errors = [];

        let params = { id: this.schedule_type_id };

        const response = await api.get("/schedule-type/get", { params });

        const { error, schedule_type, errors } = response.data;

        if (!error) {
          this.schedule_type = schedule_type;
        } else {
          this.errors = errors;
        }

        this.loading = false;
      } catch (error) {
        this.loading = false;

        console.error(error);
      }
    },

    async update() {
      try {
        this.loading = true;

        const id = this.schedule_type.id;
        const name = this.schedule_type.name;
        const active = this.schedule_type.active;

        let params = {
          id,
          name,
          active,
        };

        const response = await api.put("/schedule-type", params);

        const { error, errors, message } = response.data;

        if (!error) {
          this.$bvModal.hide("update-schedule-type");

          toast(message, "success");

          this.errors = [];

          this.$emit("update");
        } else {
          this.errors = errors;
        }

        this.loading = false;
      } catch (error) {
        this.loading = false;

        console.log(error);
      }
    },
  },
};
</script>

<style scoped>
/* Modal Styling */
.modal-title-modern {
  display: flex;
  align-items: center;
  font-size: 20px;
  font-weight: 600;
  color: #1e293b;
}

.modal-content-modern {
  padding: 8px 0;
}

.form-section {
  background: #f8fafc;
  border-radius: 12px;
  border: 1px solid #e5e7eb;
  overflow: hidden;
  transition: all 0.3s ease;
  margin-bottom: 20px;
}

.form-section:hover {
  border-color: #cbd5e1;
}

.section-header {
  background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%);
  padding: 16px 20px;
  border-bottom: 1px solid #e5e7eb;
}

.section-title {
  font-size: 16px;
  font-weight: 600;
  color: #1e293b;
  margin: 0;
  display: flex;
  align-items: center;
}

.section-title i {
  color: #0f65b0;
  font-size: 14px;
}

.section-content {
  padding: 20px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.input-icon {
  position: absolute;
  left: 12px;
  color: #6b7280;
  font-size: 14px;
  z-index: 1;
}

.modern-input {
  width: 100%;
  padding: 12px 16px 12px 40px;
  border: 2px solid #e5e7eb;
  border-radius: 8px;
  font-size: 14px;
  transition: all 0.3s ease;
  background: white;
  color: #1e293b;
}

.modern-input:focus {
  border-color: #0f65b0;
  box-shadow: 0 0 0 3px rgba(15, 101, 176, 0.1);
  outline: none;
}

.modern-input::placeholder {
  color: #9ca3af;
}

/* Toggle Buttons */
.toggle-group {
  display: flex;
  gap: 12px;
  justify-content: center;
  flex-wrap: wrap;
}

.toggle-btn {
  display: flex;
  align-items: center;
  background: white;
  color: #6b7280;
  border: 2px solid #e5e7eb;
  border-radius: 12px;
  padding: 14px 24px;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 140px;
  justify-content: center;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.toggle-btn:hover:not(.active) {
  background: #f8fafc;
  border-color: #cbd5e1;
  color: #374151;
  transform: translateY(-1px);
}

.toggle-btn.active {
  background: linear-gradient(135deg, #0f65b0 0%, #1e40af 100%);
  color: white;
  border-color: #0f65b0;
  box-shadow: 0 4px 15px rgba(15, 101, 176, 0.3);
}

.toggle-btn i {
  font-size: 16px;
}

/* Form Grid */
.form-grid {
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-bottom: 24px;
}

/* Form Actions */
.form-actions {
  display: flex;
  justify-content: flex-end;
  padding-top: 24px;
  border-top: 1px solid #e5e7eb;
  margin-top: 24px;
}

.btn-save-modern {
  background: linear-gradient(135deg, #1e884d 0%, #16a34a 100%) !important;
  color: white !important;
  border: none !important;
  border-radius: 12px !important;
  padding: 14px 32px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  box-shadow: 0 4px 15px rgba(30, 136, 77, 0.3) !important;
  transition: all 0.3s ease !important;
}

.btn-save-modern:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 20px rgba(30, 136, 77, 0.4) !important;
}

.btn-save-modern:disabled {
  opacity: 0.7 !important;
  cursor: not-allowed !important;
  transform: none !important;
}

/* Errors Section */
.errors-section {
  background: linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%);
  border: 1px solid #fca5a5;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 20px;
}

/* Responsive Design */
@media (max-width: 768px) {
  .form-grid {
    gap: 16px;
  }
  .modal-content-modern {
    padding: 0;
  }
  .form-actions {
    padding-top: 20px;
  }
  .btn-save-modern {
    width: 100% !important;
    padding: 12px 24px !important;
  }
}

@media (max-width: 480px) {
  .modal-title-modern {
    font-size: 18px;
    flex-direction: column;
    gap: 4px;
  }
  .modern-input {
    padding: 10px 14px 10px 36px;
    font-size: 13px;
  }
  .input-icon {
    left: 10px;
    font-size: 13px;
  }
}

/* Modal Header Override */
.modern-modal >>> .modal-header {
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%) !important;
  border-bottom: 1px solid #e5e7eb !important;
  border-radius: 0 !important;
  padding: 20px 24px !important;
}

.modern-modal >>> .modal-body {
  padding: 24px !important;
}

.modern-modal >>> .modal-content {
  border-radius: 16px !important;
  border: none !important;
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.15) !important;
}
</style>